import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../../common/loader";
import { formateDate, formateDateWithMonth } from "../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
// import $ from "jquery";
import { Details } from "../../../services/appointment.service";
import Breadcrums from "../../../common/breadcrumbs";
import { Placeholder} from "rsuite";

const ServiceReportsView = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const params = useParams();
  // const [query] = useSearchParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("label_service_reports_details"),
      url: "/admin/service-reports/list/1",
    },
    { title: t("btn_view"), url: "" },
  ];


  useEffect(() => {
    Details({_id :params._id})
      .then((response) => {
        // console.log("View response-", response);
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params._id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
               <div>
                <h6 className="main-content-label mb-3">{ t("label_appointment_detail")}</h6>
              </div>
              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>
                    
                        <tr>
                          <th>{t("label_booking_id")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.requestID 
                              ? showdefault?.requestID
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_user_email")}</th>
                          <td>
                          {showdefault && showdefault?.userData && showdefault?.userData?.email
                              ? showdefault?.userData?.email
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_user_name")}</th>
                          <td>
                          {showdefault && showdefault?.userData && showdefault?.userData?.name
                              ? showdefault?.userData?.name
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_user_rating")}</th>
                          <td>
                          {showdefault && showdefault?.userData && showdefault?.userData?.avgRating
                              ? showdefault?.userData?.avgRating
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_associate_email")}</th>
                          <td>
                          {showdefault && showdefault?.associateData && showdefault?.associateData?.email
                              ? showdefault?.associateData?.email
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_associate_name")}</th>
                          <td>
                          {showdefault && showdefault?.associateData && showdefault?.associateData?.name
                              ? showdefault?.associateData?.name
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_associate_rating")}</th>
                          <td>
                          {showdefault && showdefault?.associateData && showdefault?.associateData?.avgRating
                              ? showdefault?.associateData?.avgRating
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_booking_date")}</th>
                          <td>
                          {showdefault && showdefault.appointmentDate 
                              ? `${formateDateWithMonth(showdefault.appointmentDate)}`
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_status")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.status 
                              ? showdefault.status
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_price")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.subCategoryData.price 
                              ? `$${showdefault.subCategoryData.price}`
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_prescription")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.prescriptionNote 
                              ? `${showdefault.prescriptionNote}`
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_prescription_image")}</th>
                          <td>
                            <img
                              src={
                                showdefault && showdefault.prescriptionImage
                                  ? showdefault.prescriptionImage
                                  : "N/A"
                              }
                              alt="profile"
                              style={{ height: "100px" }}
                            />
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_address")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.appointmentAddress.address 
                              ? `${showdefault.appointmentAddress.address}`
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_distance")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.distance 
                              ? `${showdefault.distance} Miles`
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_category")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.categoryData.title 
                              ? `${showdefault.categoryData.title}`
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_sub_category")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.subCategoryData.title 
                              ? `${showdefault.subCategoryData.title}`
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_dispute_reason")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.disputeReason 
                              ? `${showdefault.disputeReason}`
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_dispute_reason_detail")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.disputeReasonDetails 
                              ? `${showdefault.disputeReasonDetails}`
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_cancellation_reason")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.cancelationReason 
                              ? `$${showdefault.cancelationReason}`
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_incompletion_reason")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.incompletionReason 
                              ? `$${showdefault.incompletionReason}`
                              : "N/A"}
                          </td>
                        </tr>
                        
                       
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7}/>
              )}
            </div>

            <div className="mt-2 back-button mx-4">
              <button
                className="btn ripple btn-dark ripple"
                type="button"
                onClick={() =>
                  navigate("/admin/reports/service-reports/list/1")
                }
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceReportsView;
